<div class="pane-container">
  <app-zone-overview title="Zones" (selection)="onShortcut($event)"></app-zone-overview>
  <app-action-pane [hint]="['Identifier', 'Name']" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event })"></app-action-pane>
</div>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-zone-form [creation]="true" [mode]="Mode.edition" [object]="zone" (event)="onEvent($event)"></app-zone-form>
</ng-template>
<ng-template #showList>
  <app-zone-list #list [sorting]="sorting" (event)="onEvent($event)" (sort)="onSort($event)"></app-zone-list>
</ng-template>
